import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import { Paper, Dialog, DialogContent, DialogActions, Button, Grid, Typography, TextField } from '@material-ui/core';

import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';

const styles = theme => ({
    layoutRoot: {},
    DialogPengguna: {
        width: '100%'
    },
    buttonSimpan: {
        backgroundColor: green[500],
        color: 'white',
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonTutup: {
        backgroundColor: red[500],
        color: 'white',
        '&:hover': {
            backgroundColor: red[700],
        },
    }
});

class FormPengguna extends Component {
    state = {
        dialogOpen: false,
        nama: '',
        email: '',
        password: '',
        konfirmasi_password: '',
        sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id
    }

    tutupDialog = () => {
        // this.props.toggleFormPengguna(false, '');
        this.setState({
            dialogOpen: false
        });

        if(this.state.kode === 'berhasil'){
            this.props.history.push('ManajemenPengguna')
        }
    }

    handleChange = name => event => {
        this.setState({
          [name]: event.target.value,
        });
    };

    simpanForm = () => {
        // alert('oke');
        this.props.setLoading('block');

        if(this.state.password === this.state.konfirmasi_password){
            this.props.setPengguna(this.state).then((result)=>{
                console.log(result);


                    
                if(result.hasil_pengguna.status === 'sudah_ada'){
                    this.setState({
                        dialogOpen: true,
                        dialogText: 'Email yang digunakan telah terdaftar. Silakan gunakan email lain!'
                    })
                    
                }else if(result.hasil_pengguna.status === 'berhasil'){

                    this.setState({
                        dialogOpen: true,
                        kode: 'berhasil',
                        dialogText: 'Berhasil Menambah Pengguna!'
                    })

                }else{
                    this.setState({
                        dialogOpen: true,
                        dialogText: 'Gagal Menambah Pengguna!'
                    })
                }

                this.props.setLoading('none');

            });

        }else{
            // alert('konfirmasi password tidak sama!');
            this.setState({
                dialogOpen: true,
                dialogText: 'Konfirmasi Password tidak sesuai!'
            })
        }
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot,
                    header: classes.headerUtama
                }}
                content={
                    <div style={{width: '100%'}} className="konten-utama">
                        <Dialog open={this.state.dialogOpen}>
                            <DialogContent>
                                {this.state.dialogText}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.tutupDialog}>
                                    <CloseIcon/> Tutup
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <FuseAnimate
                        animation="transition.slideRightIn"
                        duration={400}
                        delay={400}
                        >
                            <Paper className="p-16">
                                <Grid container>
                                    <Grid item xs={6} style={{textAlign:'left'}}>
                                        <Button onClick={()=>this.props.history.push('ManajemenPengguna')}>
                                            <ArrowBackIcon/> Kembali
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} style={{textAlign:'right'}}>
                                        <Button variant="contained" color="primary" onClick={this.simpanForm}>
                                            <SaveIcon/> Simpan
                                        </Button>
                                    </Grid>
                                </Grid>
                                <br/>
                                <br/>
                                <Typography variant="headline">
                                    Tambah pengguna
                                </Typography>
                                <br/>
                                <Paper className="p-16" style={{background: '#F1F8E9'}}>
                                    <Grid container>
                                        <Grid item xs={12} sm={1}>
                                            <InfoIcon style={{fontSize:35, color: '#9CCC65'}}/>
                                        </Grid>
                                        <Grid item xs={12} sm={11}>
                                            <Typography variant="caption">
                                                Menu tambah pengguna pada aplikasi PMP hanya dapat digunakan untuk menambah pengguna dengan jenis Komite Sekolah 
                                                <br/>Pengguna guru, siswa, dan pengawas diambil dari Data Pokok Pendidikan (Dapodik)
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <form style={{width: '100%'}}>
                                    <TextField
                                        id="nama"
                                        label="Nama"
                                        className={classes.textField}
                                        value={this.state.nama}
                                        onChange={this.handleChange('nama')}
                                        margin="normal"
                                        variant="outlined"
                                        style={{width: '100%'}}
                                    />
                                    <TextField
                                        id="email"
                                        label="Email"
                                        className={classes.textField}
                                        type="email"
                                        name="email"
                                        onChange={this.handleChange('email')}
                                        autoComplete="email"
                                        margin="normal"
                                        variant="outlined"
                                        style={{width: '100%'}}
                                    />
                                    <TextField
                                        id="password"
                                        label="Password"
                                        className={classes.textField}
                                        type="password"
                                        onChange={this.handleChange('password')}
                                        autoComplete="current-password"
                                        margin="normal"
                                        variant="outlined"
                                        style={{width: '100%'}}
                                    />
                                    <TextField
                                        id="konfirmasi-password"
                                        label="Konfirmasi Password"
                                        className={classes.textField}
                                        type="password"
                                        onChange={this.handleChange('konfirmasi_password')}
                                        autoComplete="current-password"
                                        margin="normal"
                                        variant="outlined"
                                        style={{width: '100%'}}
                                    />
                                    <TextField
                                        id="peran"
                                        label="Peran"
                                        className={classes.textField}
                                        value={"Komite Sekolah"}
                                        onChange={this.handleChange('peran')}
                                        margin="normal"
                                        variant="outlined"
                                        style={{width: '100%'}}
                                        disabled
                                        />
                                    <br/>
                                    <Grid container>
                                        <Grid item xs={6} style={{textAlign:'left'}}>
                                            {/* <Button onClick={()=>this.props.history.push('ManajemenPengguna')}>
                                                <ArrowBackIcon/> Kembali
                                            </Button> */}
                                        </Grid>
                                        <Grid item xs={6} style={{textAlign:'right'}}>
                                            <Button variant="contained" color="primary" onClick={this.simpanForm}>
                                                <SaveIcon/> Simpan
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Paper>
                        </FuseAnimate>
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        setPengguna: Actions.setPengguna,
        getPeran: Actions.getPeran,
        toggleFormPengguna: Actions.toggleFormPengguna,
        setLoading: Actions.setLoading
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna,
        peran: Pengguna.peran,
        hasil_pengguna: Pengguna.hasil_pengguna,
        toggle_form_pengguna: Pengguna.toggle_form_pengguna,
        loading: App.loading
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(FormPengguna)));



// WEBPACK FOOTER //
// ./src/main/content/Pengaturan/FormPengguna.js